module.exports = __webpack_public_path__ + "img/loginast2.0e8a05b4.png";